import { Injectable, Signal, signal } from '@angular/core';

/**
 * Holds the frozen flag for {@link FrozenApiInterceptor}. Deliberately free of dependencies: the
 * interceptor is built while the HTTP chain itself is being assembled, so anything it injects that
 * reaches back to HttpClient — the store does, through its effects — closes a cycle on
 * HTTP_INTERCEPTORS. The store stays the source of truth and mirrors the flag here.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiFreezeService {
  private readonly frozen = signal(false);

  readonly isFrozen: Signal<boolean> = this.frozen.asReadonly();

  freeze(): void {
    this.frozen.set(true);
  }
}
